import gsap from 'gsap'
import Flip from 'gsap/dist/Flip'

gsap.registerPlugin(Flip)

class Filtering {
  constructor() {
    this.btns = document.querySelectorAll('.js-filtering__button')
    this.items = document.querySelectorAll('.js-filtering__item')
    this.wrapper = document.querySelector('.js-filtering__wrapper')

    this.btns.forEach((element) => {
      const { filter } = element.dataset
      element.addEventListener('click', () => {
        this.updateFilters(filter)
        this.btns.forEach((el) => el.classList.toggle('is-active', el === element))
      })
    })
  }

  updateFilters(filter) {
    // First
    this.state = Flip.getState(this.items)
    const matches = filter === 'all' ? this.items : [...this.items].filter((el) => el.classList.contains(filter))
    const startHeight = gsap.getProperty(this.wrapper, 'height')

    // Last
    this.items.forEach((item) => {
      item.style.display = [...matches].indexOf(item) === -1 ? 'none' : 'block'
    })
    const endHeight = gsap.getProperty(this.wrapper, 'height')

    // Invert & Play
    this.flip = Flip.from(this.state, {
      duration: 0.7,
      ease: 'power1.inOut',
      stagger: 0.08,
      absolute: true,
      simple: true,
      onEnter: (elements) => {
        gsap.fromTo(elements, { opacity: 0 }, { opacity: 1, duration: 1 })
      },
      onLeave: (elements) => {
        gsap.to(elements, { opacity: 0, duration: 1 })
      },
    })

    this.flip.fromTo(this.wrapper, {
      height: startHeight,
    }, {
      height: endHeight,
      clearProps: 'height',
      duration: this.flip.duration(),
    }, 0)
  }
}

export default Filtering
